<template>
  <Layout name="Clean">
    <WithLoader :isLoading="!this.initialValues.mail_type">
      <div
        class="postcard-config-builder"
        :class="{ ['builder']: currentSelectorOption === 'template_object' }"
      >
        <VLayoutHeader
          :name="name"
          :label="templateName"
          :actions="getActions"
          @save="newName => saveInputValue(newName)"
          backBtn
          :maxLength="Number(255)"
        ></VLayoutHeader>
        <div class="selector-wrapper">
          <TemplateSettingsSelect
            :template="template"
            type="postcard"
            :uploaderType="currentSelectorOption"
            @changeType="
              type => {
                this.currentSelectorOption = type;
                this.saveTemplate();
              }
            "
          ></TemplateSettingsSelect>
        </div>
        <div class="settings-wrapper">
          <PostcardsTemplateSettingsForm
            :initialValues="initialValues"
            @change="saveTemplate"
          ></PostcardsTemplateSettingsForm>
        </div>

        <div
          v-show="currentSelectorOption === 'template_object'"
          class="thumbnails-wrapper"
        >
          <VThumbnailsPreview
            :thumbnails="_getThumbnails"
            type="postcard"
          ></VThumbnailsPreview>
        </div>

        <div class="html-and-preview">
          <!--HTML-selector-->
          <TemplateHtmlBuilder
            v-show="currentSelectorOption === 'html'"
            :template="this.template"
            @saveHtml="onSaveHtml"
            @changeSide="key => (this.currentTemplateSide = key)"
            extraClass="postcards-html-builder"
          ></TemplateHtmlBuilder>
          <div
            class="htmlThumbnail"
            v-show="currentSelectorOption !== 'template_object'"
          >
            <h2 class="label">Preview</h2>
            <VPreviewImage :image="_getThumbnails" hideTitle></VPreviewImage>
          </div>
        </div>

        <!--      <div v-if="_shouldButtonsAppear" class="buttons-block">-->
        <!--        <VButton-->
        <!--          size="narrow"-->
        <!--          inverted-->
        <!--          noBorder-->
        <!--          label="Reset"-->
        <!--          @click="_cancel"-->
        <!--        ></VButton>-->

        <!--        <VButton-->
        <!--          size="regular"-->
        <!--          label="Save"-->
        <!--          :disabled="isLoading"-->
        <!--          @click="saveTemplate"-->
        <!--        ></VButton>-->
        <!--      </div>-->
      </div>
    </WithLoader>
  </Layout>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
import { mapGetters, mapActions } from "vuex";

import Layout from "@/layouts/Layout";
import WithLoader from "@/components/WithLoader";

import withFormUtils from "@/mixins/withFormUtils";
import withToasted from "@/mixins/withToasted";
import withNavigate from "@/mixins/withNavigate";
import { getDefaultTemplateOpts } from "@/constants/forms";
import { required, maxLength } from "@/utils/validations";

import VLayoutHeader from "@/components/VLayoutHeader";
import TemplateSettingsSelect from "@/components/TemplateSettingsSelect";
import PostcardsTemplateSettingsForm from "@/components/PostcardsTemplateSettingsForm";
import VPreviewImage from "@/components/VPreviewImage";
import VThumbnailsPreview from "@/components/VThumbnailsPreview";
import VPreviewRenderedTemplate from "@/components/VPreviewRenderedTemplate";
import TemplateHtmlBuilder from "@/components/TemplateHtmlBuilder";
import VForm from "@/components/VForm";

import postcardPreview from "@/assets/images/postcards-preview-big.svg";

export default Vue.component("PostcardsTemplatesSettings", {
  components: {
    Layout,
    WithLoader,
    VLayoutHeader,
    TemplateSettingsSelect,
    PostcardsTemplateSettingsForm,
    VPreviewImage,
    VThumbnailsPreview,
    TemplateHtmlBuilder,
    VForm
  },

  mixins: [withFormUtils, withToasted, withNavigate],

  data() {
    const { id } = this.$route.params;

    return {
      id,
      name: "postcardTemplateSettings",
      template: null,
      templateName: "",
      initialValues: {},
      currentSelectorOption: "template_object",
      currentTemplateSide: "front",
      timerHtmlSave: 0,
      postcardPreview
    };
  },

  computed: {
    _getThumbnails() {
      // if (!this.template) {
      //   return []
      // }

      if (this.currentSelectorOption !== "template_object") {
        return this.template[`${this.currentTemplateSide}_thumbnail_url`];
      }
      return [
        this.template.front_thumbnail_url,
        this.template.back_thumbnail_url
      ];
    },

    getActions() {
      const baseActions = [
        {
          component: VPreviewRenderedTemplate,
          props: { template: this.template, templateType: "postcard" }
        }
      ];

      if (this.currentSelectorOption === "template_object") {
        return [
          ...baseActions,
          {
            label: "Go To Builder",
            value: "go_builder",
            type: "primary",
            size: "regular",
            inverted: true,
            click: () => this.goToBuilder()
          }
        ];
      }

      return baseActions;
    },

    getValuesForOldEmptyThumbnails() {
      if (
        !this.template.front_thumbnail_url &&
        !this.template.back_thumbnail_url
      ) {
        return getDefaultTemplateOpts("postcard");
      }
    },

    ...mapGetters("templates", ["getTemplate", "templates", "isLoading"])
  },

  methods: {
    saveInputValue(newName) {
      this.templateName = newName;
      this.updateTemplate({
        id: this.id,
        data: { name: this.templateName },
        onSuccess: () => {
          this.toast("Template name has been saved");
        },
        onError: () => {
          this.errorToast("Something went wrong");
        },
        // to avoid updating loading state etc
        silent: true
      });
    },

    saveTemplate() {
      const objToSave = this.formValues;
      this.updateTemplate({
        id: this.id,
        data: {
          ...objToSave,
          data_type:
            this.currentSelectorOption === "html"
              ? this.currentSelectorOption
              : "template_object",

          //fix for old templates
          ...this.getValuesForOldEmptyThumbnails
        },
        onSuccess: () => {
          this.toast("Template has been saved");
        },
        onError: () => {
          this.errorToast("Something went wrong");
        }
      });
    },

    getInitialValues() {
      if (this.template) {
        const {
          type,
          front_html,
          back_html,
          data_type,
          front_thumbnail_url,
          back_thumbnail_url,
          mail_type
        } = this.template;

        return {
          type,
          front_html: front_html || "<html></html>",
          back_html: back_html || "<html></html>",
          data_type,
          front_thumbnail_url,
          back_thumbnail_url,
          mail_type
        };
      }

      return {};
    },

    goToBuilder() {
      if (this.isFormTouched("postcardTemplateSettings")) {
        this.saveTemplate();
      }

      this.navigate({
        name: "postcards-templates-builder",
        params: { id: this.id, type: this.type }
      });
    },

    onSaveHtml() {
      if (
        this.initialValues[`${this.currentTemplateSide}_html`] !==
        this.formValues[`${this.currentTemplateSide}_html`]
      ) {
        this.saveTemplate();
      }
    },

    ...mapActions("templates", [
      "updateTemplate",
      "fetchTemplateById",
      "triggerTestPreview"
    ])
  },

  created() {
    if (!this.id) {
      this.navigate("/templates");
    }

    if (!this.isLoading) {
      this.fetchTemplateById({
        id: this.id
      });
    }
  },

  watch: {
    templates: function() {
      this.template = this.getTemplate(this.id);
    },

    template: function() {
      if (this.template) {
        this.initialValues = this.getInitialValues();
        this.templateName = this.template.name;
        this.currentSelectorOption = this.template.data_type;
      }
    }
  }
});
</script>

<style lang="scss" scoped>
$ns: "postcard-config-builder";

.#{$ns} {
  padding-bottom: 30px;
  display: grid;
  justify-content: center;
  grid-gap: 50px;
  grid-template-columns: minmax(auto, 1026px) auto;
  grid-template-rows: auto 285px 387px;
  grid-template-areas:
    "header header"
    "selector settings"
    "htmlArea htmlThumbnail";

  &.builder {
    grid-template-rows: auto 285px auto;
    grid-template-areas:
      "header header"
      "selector settings"
      "builderThumbnails builderThumbnails";

    & /deep/ .v-preview-image img {
      height: auto;
      width: 100%;
      max-width: 715px;
    }
  }
}

/*Grid areas*/
.v-template-builder-header {
  grid-area: header;
}

//TEMPORARY
// .selector-wrapper {
//   grid-area: selector;
// }

.settings-wrapper {
  grid-area: settings;
}
.postcards-html-builder {
  grid-area: htmlArea;
  margin-right: 30px;
}
.htmlThumbnail {
  grid-area: htmlThumbnail;
}
.thumbnails-wrapper {
  grid-area: builderThumbnails;
}
/*======*/

.html-and-preview {
  grid-column: 1/-1;
  display: flex;
}

.htmlThumbnail {
  display: grid;
  grid-template-rows: 34px 353px;
}

.buttons-block {
  margin-top: 60px;
  display: flex;
  justify-content: flex-end;
  :first-child {
    margin-right: 30px;
  }
}

.#{$ns} /deep/ .v-preview-image {
  padding-left: 0;
  display: initial;

  .image-wrapper {
    border-radius: 5px;
    width: auto;
    height: auto;
  }

  img {
    object-fit: contain;
    border-radius: 5px;
    display: block;
    margin: 0;
    padding: 0;
    width: auto;
    height: 350px;
  }
}

.thumbnails-wrapper {
  grid-column: 1/-1;
}

/*media*/
@media screen and (max-width: $medium-screen) {
  .#{$ns} {
    padding: 15px 50px;
    grid-template-columns: 1fr;
    grid-template-rows: none;
    grid-auto-rows: auto;
    grid-template-areas:
      "header"
      "selector"
      "htmlArea"
      "htmlThumbnail"
      "settings";

    &.builder {
      grid-template-rows: none;
      grid-template-areas:
        "header"
        "selector"
        "builderThumbnails"
        "settings";
    }
  }


  .html-and-preview {
    display: block;
  } 

  .postcards-html-builder {
    margin-right: 0;
  }

  .htmlThumbnail {
    grid-template-rows: 34px auto;
  }

  .#{$ns} /deep/ .v-preview-image {
    img {
      height: auto;
      width: 100%;
    }
  }
}

.custom-data__form-wrapper {
  overflow: auto;

  & /deep/ .v-input__label-wrapper {
    @include textCropEllipsis();

    label {
      flex-shrink: 1;
    }
  }
}
</style>
